<template>
  <el-input-number v-bind="$attrs"
                   v-on="$listeners"
                   controls-position="right"
                   size="mini"
                   :step="0.5"
                   :min="0"
                   :max="100"
                   style="width: 90px">
  </el-input-number>
</template>

<script>
  export default {
    name: 'HalfStepInput'
  }
</script>

<style scoped>

</style>
